import React from "react"
import { DckActionCreators, DckSelectors } from "dck-redux"
import * as ItemTypes from "../../../redux/items/types"
import { connect } from "react-redux"
import PropTypes from "prop-types"
import AccountingRuleCard from "./Card"

class AccountingRuleDetails extends React.Component {

  componentDidMount() {
    const { params, setCurrentId, loadData, accountingRule } = this.props
    setCurrentId(params.id);
    if(!accountingRule) {
      loadData()
    }
  }

  render() {
    const { accountingRule } = this.props
    return accountingRule ? <AccountingRuleCard accountingRule={ accountingRule } /> : <p>Loading ..</p>
  }
}

AccountingRuleDetails.propTypes = {
  accountingRule: PropTypes.object,
  setCurrentId: PropTypes.func.isRequired,
  params: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const accountingRule = DckSelectors.selectItemById(state, ItemTypes.AccountingRule, ownProps.params.id)
  return { accountingRule }
}

const mapDispatchToProps = dispatch => ({
  setCurrentId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.AccountingRule, id)),
  loadData: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.AccountingRule)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AccountingRuleDetails)



// WEBPACK FOOTER //
// ./src/components/Accounting/AccountingRules/Details.js